import { useAuth } from "../context/AuthContext";

export const useHasPermission = (requiredPermissions?: string[]): boolean => {
  const { user } = useAuth();

  if (!requiredPermissions || requiredPermissions.length === 0) {
    return true;
  }

  const userModules = new Set(
    user?.roles?.flatMap(role => role.permissions.map(p => p.moduleName)) ?? []
  );

  const userPermissionNames = new Set(
    user?.roles?.flatMap(role => role.permissions.map(p => p.name)) ?? []
  );

  return requiredPermissions.some(
    (p) => userModules.has(p) || userPermissionNames.has(p)
  );
};
